import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './CourseDetails.css';

// Local image imports (just one for example)
import javaImg from '../../components/assets/java1.png';
import pythonImg from '../../components/assets/python.webp';
import aiImg from '../../components/assets/Aiml.webp';
import dataScienceImg from '../../components/assets/Datascience.webp';
import cybersecImg from '../../components/assets/cybersec.jpeg';
import cloudDevOpsImg from '../../components/assets/cloud.jpeg';
import webDevImg from '../../components/assets/web.jpg';
import softwareTestingImg from '../../components/assets/Testing.jpg';
import digitalMarketingImg from '../../components/assets/Digital Marketing.jpg';
import sapImg from '../../components/assets/Sap.jpeg';
import mobileRepairImg from '../../components/assets/mobile.jpg';
import tvRepairImg from '../../components/assets/Tv.jpeg';
import systemRepairImg from '../../components/assets/system.jpg';
import cifImg from '../../components/assets/CIF.webp'
import makeupImg from '../../components/assets/makeup.jpg'


const courseData = {
  1: {
    title: 'Java Full Stack Course',
    category: 'Programming',
    description: 'Become a proficient Java Full Stack Developer by mastering Java, Spring Boot, Hibernate, REST APIs, and front-end technologies like HTML, CSS, JavaScript, and React. This course offers hands-on projects and real-time case studies that help you build scalable and robust web applications from scratch.',
    rating: { rate: 4.5 },
    image: javaImg,
  },
  2: {
    title: 'Python Full Stack Course',
    category: 'Programming',
    description: 'Build dynamic and responsive web applications using Python, Django, Flask, and React. This course covers the full development cycle, from backend logic and database interaction to responsive front-end development, with numerous assignments and live projects for a complete learning experience.',
    rating: { rate: 4.3 },
    image: pythonImg,
  },
  3: {
    title: 'AI and Machine Learning',
    category: 'Data Science',
    description: 'Explore the transformative world of Artificial Intelligence and Machine Learning. This course covers supervised and unsupervised learning, deep learning with neural networks, NLP, and computer vision using Python, TensorFlow, Keras, and Scikit-learn. Ideal for data enthusiasts and future AI engineers.',
    rating: { rate: 4.7 },
    image: aiImg,
  },
  4: {
    title: 'Data Science Masterclass',
    category: 'Data Science',
    description: 'Learn to collect, analyze, and visualize data using Python, Pandas, NumPy, Matplotlib, and Seaborn. This course also includes statistics, data wrangling, and predictive modeling with hands-on labs and real-world datasets for in-depth practical experience.',
    rating: { rate: 4.6 },
    image: dataScienceImg,
  },
  5: {
    title: 'Cybersecurity Course',
    category: 'Security',
    description: 'Protect systems and networks from cyber threats by learning ethical hacking, vulnerability analysis, penetration testing, firewalls, cryptography, and more. This course blends theoretical knowledge with practical skills for a career in cybersecurity or ethical hacking.',
    rating: { rate: 4.4 },
    image: cybersecImg,
  },
  6: {
    title: 'Cloud & DevOps Course',
    category: 'DevOps',
    description: 'Master the cloud platforms like AWS and Azure along with DevOps tools such as Docker, Jenkins, Kubernetes, Git, Terraform, and Ansible. Learn to automate deployments, configure infrastructure, and maintain scalable applications using CI/CD pipelines and containerization.',
    rating: { rate: 4.5 },
    image: cloudDevOpsImg,
  },
  7: {
    title: 'Web Development Course',
    category: 'Programming',
    description: 'Start with HTML, CSS, and JavaScript, then advance to React, Node.js, Express, and MongoDB. Build stunning websites and web apps with interactive UI, responsive layouts, and functional backends. Ideal for aspiring front-end and full-stack developers.',
    rating: { rate: 4.2 },
    image: webDevImg,
  },
  8: {
    title: 'Software Testing Course',
    category: 'Quality Assurance',
    description: 'Learn manual testing, automation testing with Selenium WebDriver, API testing with Postman, and frameworks like TestNG and JUnit. Understand test case creation, bug tracking, Agile methodology, and tools like Jira for QA and testing roles.',
    rating: { rate: 4.4 },
    image: softwareTestingImg,
  },
  9: {
    title: 'Digital Marketing Course',
    category: 'Marketing',
    description: 'Develop expertise in digital channels including SEO, PPC, Google Ads, social media marketing, content marketing, email campaigns, and analytics tools like Google Analytics and SEMrush. Ideal for marketers and entrepreneurs looking to grow online.',
    rating: { rate: 4.3 },
    image: digitalMarketingImg,
  },
  10: {
    title: 'SAP Training Program',
    category: 'Enterprise Software',
    description: 'Get trained in SAP ERP systems including modules like SAP FICO, MM, SD, and HANA. This course includes SAP GUI navigation, business process mapping, real-time simulations, and integration techniques used in enterprises worldwide.',
    rating: { rate: 4.5 },
    image: sapImg,
  },
  11: {
    title: 'Mobile Repair Technician Course',
    category: 'Hardware',
    description: 'Gain technical skills to repair smartphones and tablets, including diagnosis, screen replacement, charging ports, software troubleshooting, and soldering. Suitable for those wanting to open their own mobile repair shop or join service centers.',
    rating: { rate: 4.2 },
    image: mobileRepairImg,
  },
  12: {
    title: 'TV Repair Technician Course',
    category: 'Hardware',
    description: 'Learn to repair LED, LCD, and Smart TVs. The course covers hardware diagnosis, firmware flashing, motherboard servicing, panel issues, and more. Practical sessions ensure hands-on experience with various TV models.',
    rating: { rate: 4.1 },
    image: tvRepairImg,
  },
  13: {
    title: 'System Repair Technician Course',
    category: 'Hardware',
    description: 'Master PC and laptop servicing, including motherboard troubleshooting, OS installation, BIOS configuration, network setup, and hardware replacement. Ideal for aspiring hardware engineers and computer technicians.',
    rating: { rate: 4.3 },
    image: systemRepairImg,
  },
  14: {
  title: 'CIF (Customer Information File) Management Course',
  category: 'Financial',
  description: 'Comprehensive training on managing customer information files in banking and financial services. Learn data entry, verification processes, compliance requirements, and updating customer records with accuracy and security.',
  rating: { rate: 4.4 },
  image: cifImg,  // Make sure cifImg is imported or defined in your assets
},
15: {
  title: 'Makeup Artist Professional Course',
  category: 'Beauty',
  description: 'Become a certified makeup artist by learning skin care basics, makeup tools, day and evening looks, bridal makeup, special effects, and professional client handling. Hands-on practice and expert tips included.',
  rating: { rate: 4.6 },
  image: makeupImg,  // Make sure makeupImg is imported or defined in your assets
},
};

const courseSyllabuses = {
  1: { // Java Full Stack
    Beginner: [
      'Introduction to Java Programming',
      'Basic Syntax and Data Types in Java',
      'Control Flow in Java',
      'Functions and Methods in Java',
      'Arrays and Collections in Java',
      'Introduction to Object-Oriented Programming (OOP)',
      'Classes and Objects in Java',
      'Constructors in Java',
      'Access Modifiers in Java',
      'ArrayList, HashMap in Java',
      'Understanding Java Compilation and JVM',
      'Working with Strings and StringBuilder',
      'Introduction to IDEs (Eclipse, IntelliJ)',
      'Debugging with Breakpoints and Stack Trace',
      'Reading and Writing Files in Java',
      'Working with Enums and Switch Statements',
    ],
    Intermediate: [
      'Object-Oriented Programming Concepts',
      'Encapsulation and Inheritance in Java',
      'Polymorphism and Abstraction in Java',
      'Exception Handling in Java',
      'Working with Java Collections (List, Set, Map)',
      'Introduction to Multithreading in Java',
      'Working with Threads in Java',
      'Synchronization in Java',
      'Java Streams API',
      'Lambda Expressions in Java',
      'Working with Java I/O and Serialization',
      'Unit Testing with JUnit Basics',
      'Refactoring and Code Optimization Techniques',
      'Working with Java Annotations',
      'Introduction to Maven and Gradle',
    ],
    Advanced: [
      'Building Web Apps with Spring and Hibernate',
      'Spring Boot Fundamentals',
      'Dependency Injection in Spring Framework',
      'Building REST APIs with Spring Boot',
      'Hibernate ORM and Database Interaction',
      'Spring Security and JWT',
      'Working with JPA and Hibernate in Spring',
      'Test-Driven Development with JUnit and Mockito',
      'Creating WebSocket-based Applications with Spring',
      'Consuming REST APIs in Spring Boot',
      'Microservices with Spring Boot',
      'Spring Cloud Basics',
      'API Gateway and Service Registry (Eureka, Zuul)',
      'Building Scalable Apps with Spring Boot',
      'Working with Caching in Java (Ehcache, Redis)',
      'Java 8 Features: Streams, Optional, Date/Time API',
      'Testing REST APIs with Postman and JUnit',
      'Logging and Monitoring in Java Applications (Logback, ELK)',
      'Deploying Java Apps to Cloud Platforms (AWS, Azure)',
      'Optimizing Java Applications for Performance',
      'CI/CD Pipeline for Java Applications',
      'Security Best Practices in Java Web Apps',
      'Java Microservices Security',
      'Introduction to Reactive Programming in Java',
      'Building Reactive APIs with Spring WebFlux',
      'Kafka and Event-Driven Architecture in Java',
      'Integrating Java Applications with Databases',
      'Java Unit Testing with JUnit and TestNG',
      'Java Performance Tuning and Profiling',
      'Best Practices in Java Development',
      'Version Control with Git for Java Developers',
      'Dockerizing Java Applications',
      'Kubernetes Basics for Java Developers',
      'Monitoring Java Apps with Prometheus & Grafana',
      'Rate Limiting and Throttling APIs',
      'Introduction to GraphQL in Java',
      'Feature Flags and A/B Testing in Java Apps',
      'Building Full Stack Apps with Java and React',
      'Building Real-Time Applications in Java',
      'Debugging and Troubleshooting in Java Applications',
    ],
  },

  2: { // Python Full Stack
    Beginner: [
      'Introduction to Python Programming',
      'Python Syntax and Data Types',
      'Control Flow and Loops in Python',
      'Functions and Modules in Python',
      'Working with Lists and Dictionaries in Python',
      'Working with Tuples, Sets, and Dictionaries',
      'File Handling in Python',
      'Error Handling in Python',
      'Introduction to Object-Oriented Programming',
      'Classes and Objects in Python',
      'Using Python in Jupyter Notebook',
      'Working with JSON and CSV files',
      'Exploring Python Libraries (math, random, datetime)',
      'Python List Comprehensions and Generators',
      'Understanding Python Virtual Environments',
    ],
    Intermediate: [
      'Working with Databases in Python',
      'Connecting to SQL Databases with Python',
      'Using SQLAlchemy for ORM in Python',
      'Python Libraries: NumPy, Pandas',
      'Regular Expressions in Python',
      'Introduction to Flask Framework',
      'Flask Basics and Routing',
      'Template Rendering in Flask',
      'Session Management in Flask',
      'Flask with SQLAlchemy for Database Integration',
      'Python Logging and Debugging Techniques',
      'Building APIs with Flask',
      'API Testing with Postman',
      'User Authentication with Flask',
      'Introduction to Django Framework',
      'Django Models and Views',
      'Django Templates and Static Files',
      'Database Migrations in Django',
      'Introduction to React for Python Developers',
      'React Basics and Components',
      'React State Management with Redux',
      'Building Forms in React',
      'Connecting React with Flask/Django API',
      'Creating RESTful APIs with Flask and Django',
      'User Authentication in Full Stack Apps',
      'Deploying Python Web Apps on AWS',
      'Using Docker with Python Web Apps',
      'Unit Testing in Python',
      'Debugging Flask/Django Apps',
      'Environment Variable Management with dotenv',
    ],
    Advanced: [
      'Advanced Django Features (Celery, Channels)',
      'Building GraphQL APIs with Python',
      'Microservices Architecture with Flask',
      'CI/CD for Python Web Apps',
      'Scaling Flask Applications for Production',
      'Implementing Search Functionality with Elasticsearch',
      'Event-Driven Architecture with Python',
      'Building Real-Time Apps with Flask and WebSockets',
      'Deploying to Kubernetes with Flask/Django',
      'Building Serverless Python Web Apps',
      'Graph Databases with Python',
      'Integrating Third-Party APIs with Flask/Django',
      'Security Best Practices in Flask/Django',
      'Integrating Python Web Apps with Machine Learning Models',
      'Handling Asynchronous Tasks in Flask with Celery',
      'Python Web App Deployment Strategies',
      'Advanced Python Libraries for Web Scraping',
      'Creating Custom Middleware in Flask',
      'Optimizing Python Web Apps for Performance',
      'Building Scalable Python Web Apps',
      'Monitoring and Logging for Python Web Apps',
      'Advanced Authentication with OAuth2 and JWT',
      'Sentry and Error Tracking in Production Apps',
      'Rate Limiting and Throttling APIs with Flask',
      'Using Apache Kafka with Python Microservices',
      'Managing API Keys and Secrets',
      'Zero Downtime Deployment Strategies',
      'Feature Toggles and Config Servers in Django',
    ],
    Beginner: [
      'Introduction to AI and Machine Learning',
      'Understanding Supervised vs Unsupervised Learning',
      'Linear Regression and Classification Basics',
      'Introduction to Data Preprocessing',
      'Exploratory Data Analysis (EDA)',
      'Introduction to Neural Networks',
      'Basic Clustering Algorithms',
      'Data Cleaning and Missing Values Handling',
      'Feature Engineering and Feature Selection',
      'Introduction to Model Evaluation (Accuracy, Precision, Recall)',
      'Bias-Variance Tradeoff',
      'Model Overfitting and Underfitting',
      'Introduction to Time Series Analysis',
      'Working with Text Data: Tokenization and Vectorization',
      'Introduction to Feature Scaling (Standardization, Normalization)',
      'Basic Data Visualization Techniques (Histograms, Scatter Plots)',
      'Introduction to Deep Learning Concepts',
      'Handling Categorical Data'
    ],
    Intermediate: [
      'Supervised and Unsupervised Learning',
      'K-Nearest Neighbors Algorithm',
      'Decision Trees and Random Forests',
      'Clustering Algorithms: K-Means, DBSCAN',
      'Dimensionality Reduction: PCA',
      'Support Vector Machines (SVM)',
      'Naive Bayes Classifier',
      'Model Selection and Cross-Validation',
      'Handling Imbalanced Datasets',
      'Hyperparameter Tuning with GridSearchCV',
      'Ensemble Methods: Bagging, Boosting, and Stacking',
      'Artificial Neural Networks (ANN)',
      'Transfer Learning Basics',
      'Introduction to Recommender Systems',
      'Introduction to Reinforcement Learning',
      'Introduction to Time Series Forecasting (ARIMA)',
      'Data Augmentation Techniques',
      'Working with Large Datasets using TensorFlow Datasets',
      'Natural Language Processing: Text Classification and Sentiment Analysis',
      'Hyperparameter Optimization with Random Search',
      'Advanced Feature Engineering Techniques'
    ],
    Advanced: [
      'Deep Learning and Neural Networks',
      'Introduction to Neural Networks and Backpropagation',
      'Convolutional Neural Networks (CNNs) for Image Recognition',
      'Recurrent Neural Networks (RNNs) for Sequence Data',
      'Generative Adversarial Networks (GANs)',
      'Reinforcement Learning and Q-Learning',
      'Natural Language Processing with Python',
      'Transfer Learning in Deep Learning',
      'Deploying Machine Learning Models to Production',
      'Model Evaluation and Hyperparameter Tuning',
      'Building Neural Networks with TensorFlow/Keras',
      'Building Predictive Models for Business Analytics',
      'Ethical Considerations in AI and Machine Learning',
      'Deep Reinforcement Learning',
      'AI Model Interpretability and Explainability',
      'Building AI Chatbots and Virtual Assistants',
      'Computer Vision with OpenCV and TensorFlow',
      'Sentiment Analysis with Machine Learning',
      'Recommendation Systems with Machine Learning',
      'Time Series Forecasting with ARIMA and LSTM',
      'AI for Healthcare and Medical Data Analysis',
      'AI in Autonomous Systems and Robotics',
      'AI for Financial Modeling and Stock Price Prediction',
      'Advanced Natural Language Processing Techniques',
      'AI and Machine Learning for Cybersecurity',
      'AI in Marketing and Customer Segmentation',
      'Building Real-Time ML Systems',
      'AI in Edge Computing and IoT',
      'Ethical AI and Fairness in Machine Learning'
    ]
  },

  3: { // AI and Machine Learning Course (Expanded)
    Beginner: [
      'Introduction to AI and Machine Learning',
      'Understanding Supervised vs Unsupervised Learning',
      'Linear Regression and Classification Basics',
      'Introduction to Data Preprocessing',
      'Exploratory Data Analysis (EDA)',
      'Introduction to Python for Data Science',
      'Introduction to Libraries: NumPy, Pandas, Matplotlib',
      'Basic Statistical Concepts for Machine Learning',
      'Data Wrangling and Feature Engineering',
      'Introduction to Model Evaluation Metrics',
      'Working with Missing Data and Outliers',
      'Understanding Overfitting and Underfitting',
      'Basic Data Visualization Techniques',
      'Data Types and Structure for Machine Learning',
      'Introduction to Neural Networks',
      'Basic Concepts of Bias and Variance'
    ],
    Intermediate: [
      'Supervised and Unsupervised Learning',
      'K-Nearest Neighbors Algorithm',
      'Decision Trees and Random Forests',
      'Clustering Algorithms: K-Means, DBSCAN',
      'Dimensionality Reduction: PCA',
      'Support Vector Machines (SVM)',
      'Naive Bayes Classifier',
      'Hyperparameter Tuning and Grid Search',
      'Cross-Validation and Model Selection',
      'Feature Scaling and Normalization',
      'Time Series Data and Forecasting',
      'Building Regressors and Classifiers from Scratch',
      'Introduction to Natural Language Processing (NLP)',
      'Working with Text Data and Tokenization',
      'Ensemble Methods: Bagging, Boosting, Stacking',
      'Model Interpretability with SHAP and LIME',
      'Anomaly Detection Algorithms',
      'Handling Imbalanced Datasets',
      'Advanced Feature Engineering Techniques',
      'Model Deployment and Versioning',
      'Evaluation Metrics for NLP: Precision, Recall, F1-Score',
      'Topic Modeling and Latent Dirichlet Allocation (LDA)',
      'Transfer Learning and Fine-Tuning Pre-trained Models'
    ],
    Advanced: [
      'Deep Learning and Neural Networks',
      'Introduction to Neural Networks and Backpropagation',
      'Convolutional Neural Networks (CNNs) for Image Recognition',
      'Recurrent Neural Networks (RNNs) for Sequence Data',
      'Generative Adversarial Networks (GANs)',
      'Reinforcement Learning and Q-Learning',
      'Natural Language Processing with Python',
      'Transfer Learning in Deep Learning',
      'Deploying Machine Learning Models to Production',
      'Model Evaluation and Hyperparameter Tuning',
      'Building Neural Networks with TensorFlow/Keras',
      'Building Predictive Models for Business Analytics',
      'Ethical Considerations in AI and Machine Learning',
      'Deep Reinforcement Learning',
      'AI Model Interpretability and Explainability',
      'Building AI Chatbots and Virtual Assistants',
      'Computer Vision with OpenCV and TensorFlow',
      'Sentiment Analysis with Machine Learning',
      'Recommendation Systems with Machine Learning',
      'Time Series Forecasting with ARIMA and LSTM',
      'AI for Healthcare and Medical Data Analysis',
      'AI in Autonomous Systems and Robotics',
      'AI for Financial Modeling and Stock Price Prediction',
      'Advanced NLP Techniques: Transformers and BERT',
      'AI for Cybersecurity and Fraud Detection',
      'AI in Robotics and Automation',
      'Building Scalable Machine Learning Pipelines',
      'Cloud-Based Machine Learning with AWS and Azure',
      'Explainable AI (XAI) Techniques for Transparency',
      'AI for Smart Cities and IoT Integration',
      'Ethical and Fair AI Models',
      'Quantum Machine Learning',
      'AI for Predictive Maintenance',
      'AI in Supply Chain and Logistics Optimization',
      'AI in Marketing: Customer Segmentation and Personalization',
      'Self-Supervised Learning: The Next Frontier',
      'AI in Audio Processing and Speech Recognition',
      'Neural Networks for Graph Data and Social Networks',
      'Building Intelligent Virtual Agents with AI',
      'AI for Game Development and Strategy Optimization',
      'AI in Climate Modeling and Environmental Protection',
      'AI-Powered Personalized Education Systems',
      'Causal Inference in Machine Learning',
      'AI for Behavioral Analysis and Consumer Insight',
      'Reinforcement Learning for Resource Allocation Problems',
      'AI for Computational Biology and Drug Discovery',
      'Federated Learning and Data Privacy in AI Models',
      'AI in the Legal Industry: Case Law Prediction and Automation',
      'AI in Smart Manufacturing and Industry 4.0',
      'AI for Automated Content Generation and Journalism',
      'Adversarial Machine Learning and Robustness',
      'Neural Architecture Search (NAS)',
      'Meta-Learning and Few-Shot Learning Techniques',
      'Explainable AI for Decision Making',
      'Augmented Reality (AR) and AI Integration for User Interaction',
      'AI for Personal Assistants and Smart Devices',
      'AI for Intelligent Healthcare Diagnostics and Prognostics',
      'AI in Digital Twins and Simulation Models',
      'AI for Predictive Policing and Security Systems',
      'AI in Behavioral Health and Mental Health Treatment',
      'AI in Fashion and Design: Predicting Trends and Consumer Behavior',
      'AI in Human Resource Management: Recruiting and Talent Analytics',
      'AI in Space Exploration: Satellite Data Processing and Analysis',
      'Autonomous Vehicles and Traffic Management with AI',
      'AI in Video Surveillance and Public Safety',
      'Data Augmentation Techniques for AI Model Improvement',
      'AI for Content Moderation in Social Media Platforms',
      'Ethics in AI: The Debate on AI in Warfare',
      'Building and Optimizing Chatbots for Customer Service',
      'AI for Artistic Creation: Music, Art, and Literature',
      'Neural-Symbolic Systems: Combining Neural Networks and Logic',
      'AI for Financial Risk Assessment and Portfolio Management',
      'AI-Driven Healthcare Data Analytics: EHR and Medical Imaging',
      'Blockchain and AI Integration for Security and Data Integrity',
      'AI for Customer Support Automation and Help Desks',
      'AI for Optimizing eCommerce Inventory Management'
    ]
  },
  

  4: { // Data Science Masterclass
    Beginner: [
      'Introduction to Data Science and its Applications',
      'Understanding Data Structures and Algorithms',
      'Python for Data Science',
      'Introduction to Data Analysis and Visualization',
      'Working with NumPy and Pandas',
      'Basic Data Cleaning Techniques',
      'Data Wrangling and Transformation',
      'Data Collection Methods',
      'Introduction to Databases (SQL)',
      'Data Exploration using Pandas',
      'Introduction to Data Visualization with Matplotlib',
      'Introduction to Jupyter Notebooks and Data Science Tools',
      'Data Exploration with Histograms, Box Plots, and Heatmaps'
    ],
    Intermediate: [
      'Exploratory Data Analysis (EDA)',
      'Data Preprocessing and Cleaning',
      'Data Visualization with Matplotlib and Seaborn',
      'Statistical Analysis and Probability in Data Science',
      'Regression Analysis and Prediction Models',
      'Data Feature Engineering and Scaling',
      'Handling Missing Data and Outliers',
      'Statistical Inference and Hypothesis Testing',
      'Time Series Data Analysis with Pandas',
      'Working with Big Data using PySpark',
      'Clustering Techniques (K-Means, DBSCAN)',
      'Principal Component Analysis (PCA)',
      'Statistical Modeling and Linear Regression',
      'Model Evaluation and Metrics',
      'Data-Driven Decision Making',
      'Introduction to Data Ethics and Privacy',
      'Working with Text Data (Natural Language Processing)'
    ],
    Advanced: [
      'Machine Learning for Data Science',
      'Supervised Learning Algorithms',
      'Unsupervised Learning Algorithms',
      'Clustering, PCA and Dimensionality Reduction',
      'Model Evaluation and Selection',
      'Deep Learning Techniques for Data Science',
      'Time Series Analysis and Forecasting',
      'Natural Language Processing for Text Data',
      'Big Data Technologies (Hadoop, Spark)',
      'Data Science for Business Analytics',
      'Deep Learning with TensorFlow and Keras',
      'Data Science Projects and Case Studies',
      'AI Ethics and Responsible Data Science',
      'Advanced Data Visualization Techniques',
      'Deploying Data Science Models to Production',
      'Creating Dashboards with Power BI and Tableau',
      'Data Science for Financial Data Analysis',
      'Advanced Machine Learning Algorithms',
      'Artificial Intelligence and Data Science Integration',
      'Data Science for Social Media Analytics',
      'Big Data Architecture and Tools',
      'Data Science for Marketing Analytics',
      'Data Science in Healthcare and Bioinformatics'
    ]
  },

  5: { // Cybersecurity Course
    Beginner: [
      'Introduction to Cybersecurity',
      'Understanding Network Security',
      'Cybersecurity Terminology and Principles',
      'Types of Cyber Attacks',
      'Network Security Tools and Techniques',
      'Introduction to Firewalls',
      'Cryptography Basics',
      'Malware and Viruses: Types and Protection',
      'Introduction to Ethical Hacking',
      'Cybersecurity Risk Assessment',
      'Introduction to Cybersecurity Laws and Regulations',
      'Social Engineering Attacks and Mitigation Techniques',
      'Phishing Attacks: Identification and Prevention'
    ],
    Intermediate: [
      'Network Defense Strategies',
      'Firewalls and Intrusion Detection Systems',
      'Security Operations Center (SOC)',
      'Penetration Testing Tools and Techniques',
      'Ethical Hacking and Exploits',
      'Vulnerability Assessment',
      'Cryptography and Data Encryption',
      'Network Monitoring and Threat Detection',
      'Web Application Security',
      'Digital Forensics',
      'Advanced Malware Analysis',
      'Data Privacy Laws (GDPR, CCPA)',
      'Incident Response Planning and Procedures',
      'Penetration Testing Methodology and Tools',
      'Security Awareness Training',
      'Threat Intelligence and Analysis',
      'Blockchain Security'
    ],
    Advanced: [
      'Advanced Cybersecurity Threats',
      'Advanced Ethical Hacking Techniques',
      'Cybersecurity in the Cloud',
      'Incident Response and Management',
      'Advanced Cryptography and Secure Communications',
      'Security in IoT Devices',
      'Building Secure Software Systems',
      'Advanced Penetration Testing and Exploitation',
      'Blockchain Security and Cryptographic Protocols',
      'Security Policies and Compliance',
      'Security Risk Management',
      'Cybersecurity for Mobile Devices',
      'Red Team vs Blue Team Strategies',
      'Zero Trust Architecture',
      'Security in DevSecOps',
      'Advanced Threat Hunting Techniques',
      'AI and Machine Learning for Cybersecurity',
      'Advanced Persistent Threats (APT) Detection',
      'Security of Critical Infrastructure'
    ]
  },

  6: { // Cloud & DevOps Course
    Beginner: [
      'Introduction to Cloud Computing',
      'Types of Cloud Deployment Models',
      'Introduction to DevOps',
      'Cloud Service Models: IaaS, PaaS, SaaS',
      'Setting up Cloud Infrastructure',
      'Virtualization and Cloud Basics',
      'Getting Started with AWS and Azure',
      'Introduction to Version Control Systems',
      'Git and GitHub Basics',
      'Continuous Integration (CI) and Continuous Deployment (CD)',
      'Cloud Cost Management and Billing',
      'Cloud Storage Services',
      'Basic Networking Concepts for Cloud'
    ],
    Intermediate: [
      'AWS Cloud Services and Tools',
      'Setting up AWS EC2 Instances',
      'Infrastructure as Code with Terraform',
      'Docker Basics and Containerization',
      'Building Docker Images and Containers',
      'Kubernetes for Container Orchestration',
      'Continuous Integration with Jenkins',
      'Configuration Management with Ansible',
      'Scaling Applications in Cloud',
      'Load Balancing and Auto-scaling in AWS',
      'Serverless Architectures in AWS',
      'Container Orchestration with Kubernetes',
      'Cloud Database Services (RDS, DynamoDB)',
      'Monitoring Cloud Applications and Services',
      'Cloud Security Best Practices',
      'Disaster Recovery and High Availability Design'
    ],
    Advanced: [
      'Advanced Cloud Security and Networking',
      'DevOps Automation with CI/CD Pipelines',
      'Cloud Monitoring and Performance Optimization',
      'Advanced Docker and Kubernetes',
      'Cloud-Native Applications Development',
      'Implementing Microservices in Cloud',
      'Managing Multi-Cloud Environments',
      'DevOps with GitLab and Azure DevOps',
      'Security Best Practices in DevOps',
      'Infrastructure as Code with AWS CloudFormation',
      'Advanced Monitoring and Alerting in Cloud',
      'Cloud Disaster Recovery and Backup Solutions',
      'Cloud DevOps Automation with Serverless Architectures',
      'Hybrid Cloud Architectures',
      'Advanced Network Architectures in Cloud',
      'Cloud Automation and Scaling Solutions',
      'Serverless Computing: AWS Lambda and Azure Functions',
      'Advanced Cloud Governance and Compliance'
    ],


 
    Beginner: [
      'Introduction to AI and Machine Learning',
      'Understanding Supervised vs Unsupervised Learning',
      'Linear Regression and Classification Basics',
      'Introduction to Data Preprocessing',
      'Exploratory Data Analysis (EDA)',
      'Introduction to Neural Networks',
      'Basic Clustering Algorithms',
      'Data Cleaning and Missing Values Handling',
      'Feature Engineering and Feature Selection',
      'Introduction to Model Evaluation (Accuracy, Precision, Recall)',
      'Bias-Variance Tradeoff',
      'Model Overfitting and Underfitting',
      'Introduction to Time Series Analysis',
      'Working with Text Data: Tokenization and Vectorization',
      'Introduction to Feature Scaling (Standardization, Normalization)',
      'Basic Data Visualization Techniques (Histograms, Scatter Plots)',
      'Introduction to Deep Learning Concepts',
      'Handling Categorical Data'
    ],
    Intermediate: [
      'Supervised and Unsupervised Learning',
      'K-Nearest Neighbors Algorithm',
      'Decision Trees and Random Forests',
      'Clustering Algorithms: K-Means, DBSCAN',
      'Dimensionality Reduction: PCA',
      'Support Vector Machines (SVM)',
      'Naive Bayes Classifier',
      'Model Selection and Cross-Validation',
      'Handling Imbalanced Datasets',
      'Hyperparameter Tuning with GridSearchCV',
      'Ensemble Methods: Bagging, Boosting, and Stacking',
      'Artificial Neural Networks (ANN)',
      'Transfer Learning Basics',
      'Introduction to Recommender Systems',
      'Introduction to Reinforcement Learning',
      'Introduction to Time Series Forecasting (ARIMA)',
      'Data Augmentation Techniques',
      'Working with Large Datasets using TensorFlow Datasets',
      'Natural Language Processing: Text Classification and Sentiment Analysis',
      'Hyperparameter Optimization with Random Search',
      'Advanced Feature Engineering Techniques',
      'Handling Real-World Noisy Data'
    ],
    Advanced: [
      'Deep Learning and Neural Networks',
      'Introduction to Neural Networks and Backpropagation',
      'Convolutional Neural Networks (CNNs) for Image Recognition',
      'Recurrent Neural Networks (RNNs) for Sequence Data',
      'Generative Adversarial Networks (GANs)',
      'Reinforcement Learning and Q-Learning',
      'Natural Language Processing with Python',
      'Transfer Learning in Deep Learning',
      'Deploying Machine Learning Models to Production',
      'Model Evaluation and Hyperparameter Tuning',
      'Building Neural Networks with TensorFlow/Keras',
      'Building Predictive Models for Business Analytics',
      'Ethical Considerations in AI and Machine Learning',
      'Deep Reinforcement Learning',
      'AI Model Interpretability and Explainability',
      'Building AI Chatbots and Virtual Assistants',
      'Computer Vision with OpenCV and TensorFlow',
      'Sentiment Analysis with Machine Learning',
      'Recommendation Systems with Machine Learning',
      'Time Series Forecasting with ARIMA and LSTM',
      'AI for Healthcare and Medical Data Analysis',
      'AI in Autonomous Systems and Robotics',
      'AI for Financial Modeling and Stock Price Prediction',
      'Advanced Natural Language Processing Techniques',
      'AI and Machine Learning for Cybersecurity',
      'AI in Marketing and Customer Segmentation',
      'Building Real-Time ML Systems',
      'AI in Edge Computing and IoT',
      'Ethical AI and Fairness in Machine Learning',
      'Automated Machine Learning (AutoML) and Model Selection'
    ]
  },

  4: { // Data Science Masterclass
    Beginner: [
      'Introduction to Data Science and its Applications',
      'Understanding Data Structures and Algorithms',
      'Python for Data Science',
      'Introduction to Data Analysis and Visualization',
      'Working with NumPy and Pandas',
      'Basic Data Cleaning Techniques',
      'Data Wrangling and Transformation',
      'Data Collection Methods',
      'Introduction to Databases (SQL)',
      'Data Exploration using Pandas',
      'Introduction to Data Visualization with Matplotlib',
      'Introduction to Jupyter Notebooks and Data Science Tools',
      'Data Exploration with Histograms, Box Plots, and Heatmaps',
      'Basic Machine Learning Concepts and Algorithms'
    ],
    Intermediate: [
      'Exploratory Data Analysis (EDA)',
      'Data Preprocessing and Cleaning',
      'Data Visualization with Matplotlib and Seaborn',
      'Statistical Analysis and Probability in Data Science',
      'Regression Analysis and Prediction Models',
      'Data Feature Engineering and Scaling',
      'Handling Missing Data and Outliers',
      'Statistical Inference and Hypothesis Testing',
      'Time Series Data Analysis with Pandas',
      'Working with Big Data using PySpark',
      'Clustering Techniques (K-Means, DBSCAN)',
      'Principal Component Analysis (PCA)',
      'Statistical Modeling and Linear Regression',
      'Model Evaluation and Metrics',
      'Data-Driven Decision Making',
      'Introduction to Data Ethics and Privacy',
      'Working with Text Data (Natural Language Processing)',
      'Advanced Feature Engineering and Feature Selection',
      'Data Visualization with Plotly and Dash'
    ],
    Advanced: [
      'Machine Learning for Data Science',
      'Supervised Learning Algorithms',
      'Unsupervised Learning Algorithms',
      'Clustering, PCA and Dimensionality Reduction',
      'Model Evaluation and Selection',
      'Deep Learning Techniques for Data Science',
      'Time Series Analysis and Forecasting',
      'Natural Language Processing for Text Data',
      'Big Data Technologies (Hadoop, Spark)',
      'Data Science for Business Analytics',
      'Deep Learning with TensorFlow and Keras',
      'Data Science Projects and Case Studies',
      'AI Ethics and Responsible Data Science',
      'Advanced Data Visualization Techniques',
      'Deploying Data Science Models to Production',
      'Creating Dashboards with Power BI and Tableau',
      'Data Science for Financial Data Analysis',
      'Advanced Machine Learning Algorithms',
      'Artificial Intelligence and Data Science Integration',
      'Data Science for Social Media Analytics',
      'Big Data Architecture and Tools',
      'Data Science for Marketing Analytics',
      'Data Science in Healthcare and Bioinformatics',
      'Feature Engineering for Model Performance',
      'Model Deployment with Flask and FastAPI'
    ]
  },

  5: { // Cybersecurity Course
    Beginner: [
      'Introduction to Cybersecurity',
      'Understanding Network Security',
      'Cybersecurity Terminology and Principles',
      'Types of Cyber Attacks',
      'Network Security Tools and Techniques',
      'Introduction to Firewalls',
      'Cryptography Basics',
      'Malware and Viruses: Types and Protection',
      'Introduction to Ethical Hacking',
      'Cybersecurity Risk Assessment',
      'Introduction to Cybersecurity Laws and Regulations',
      'Social Engineering Attacks and Mitigation Techniques',
      'Phishing Attacks: Identification and Prevention',
      'Cybersecurity Tools and Platforms Overview'
    ],
    Intermediate: [
      'Network Defense Strategies',
      'Firewalls and Intrusion Detection Systems',
      'Security Operations Center (SOC)',
      'Penetration Testing Tools and Techniques',
      'Ethical Hacking and Exploits',
      'Vulnerability Assessment',
      'Cryptography and Data Encryption',
      'Network Monitoring and Threat Detection',
      'Web Application Security',
      'Digital Forensics',
      'Advanced Malware Analysis',
      'Data Privacy Laws (GDPR, CCPA)',
      'Incident Response Planning and Procedures',
      'Penetration Testing Methodology and Tools',
      'Security Awareness Training',
      'Threat Intelligence and Analysis',
      'Blockchain Security',
      'Cloud Security Fundamentals',
      'Threat Modeling and Risk Assessment'
    ],
    Advanced: [
      'Advanced Cybersecurity Threats',
      'Advanced Ethical Hacking Techniques',
      'Cybersecurity in the Cloud',
      'Incident Response and Management',
      'Advanced Cryptography and Secure Communications',
      'Security in IoT Devices',
      'Building Secure Software Systems',
      'Advanced Penetration Testing and Exploitation',
      'Blockchain Security and Cryptographic Protocols',
      'Security Policies and Compliance',
      'Security Risk Management',
      'Cybersecurity for Mobile Devices',
      'Red Team vs Blue Team Strategies',
      'Zero Trust Architecture',
      'Security in DevSecOps',
      'Advanced Threat Hunting Techniques',
      'AI and Machine Learning for Cybersecurity',
      'Advanced Persistent Threats (APT) Detection',
      'Security of Critical Infrastructure',
      'Cryptocurrency Security',
      'Security Automation and Orchestration',
      'Advanced Cloud Security',
      'Post-Breach Security Techniques'
    ]
  },

  6: { // Cloud & DevOps Course
    Beginner: [
      'Introduction to Cloud Computing',
      'Types of Cloud Deployment Models',
      'Introduction to DevOps',
      'Cloud Service Models: IaaS, PaaS, SaaS',
      'Setting up Cloud Infrastructure',
      'Virtualization and Cloud Basics',
      'Getting Started with AWS and Azure',
      'Introduction to Version Control Systems',
      'Git and GitHub Basics',
      'Continuous Integration (CI) and Continuous Deployment (CD)',
      'Cloud Cost Management and Billing',
      'Cloud Storage Services',
      'Basic Networking Concepts for Cloud',
      'Introduction to Containerization with Docker',
      'Security in Cloud Environments'
    ],
    Intermediate: [
      'AWS Cloud Services and Tools',
      'Setting up AWS EC2 Instances',
      'Infrastructure as Code with Terraform',
      'Docker Basics and Containerization',
      'Building Docker Images and Containers',
      'Kubernetes for Container Orchestration',
      'Continuous Integration with Jenkins',
      'Configuration Management with Ansible',
      'Scaling Applications in Cloud',
      'Load Balancing and Auto-scaling in AWS',
      'Serverless Architectures in AWS',
      'Container Orchestration with Kubernetes',
      'Cloud Database Services (RDS, DynamoDB)',
      'Monitoring Cloud Applications and Services',
      'Cloud Security Best Practices',
      'Disaster Recovery and High Availability Design',
      'CI/CD Pipelines for Cloud-Native Applications'
    ],
    Advanced: [
      'Advanced Cloud Security and Networking',
      'DevOps Automation with CI/CD Pipelines',
      'Cloud Monitoring and Performance Optimization',
      'Advanced Docker and Kubernetes',
      'Cloud-Native Applications Development',
      'Implementing Microservices in Cloud',
      'Managing Multi-Cloud Environments',
      'DevOps with GitLab and Azure DevOps',
      'Security Best Practices in DevOps',
      'Infrastructure as Code with AWS CloudFormation',
      'Advanced Monitoring and Alerting in Cloud',
      'Cloud Disaster Recovery and Backup Solutions',
      'Cloud DevOps Automation with Serverless Architectures',
      'Hybrid Cloud Architectures',
      'Advanced Network Architectures in Cloud',
      'Cloud Automation and Scaling Solutions',
      'Serverless Computing: AWS Lambda and Azure Functions',
      'Advanced Cloud Governance and Compliance',
      'Cloud-Native DevOps for Microservices',
      'Edge Computing with Cloud Platforms'
    ]
  },
  
    7: { // Web Development Course
      Beginner: [
        'Introduction to Web Development',
        'HTML Basics',
        'CSS Basics',
        'JavaScript Basics',
        'Building Simple Web Pages with HTML and CSS',
        'Responsive Web Design with Media Queries',
        'JavaScript DOM Manipulation',
        'Introduction to Git and GitHub',
        'Debugging JavaScript in Browser',
        'Introduction to Web Development Tools',
        'Introduction to Web Hosting and Domain Names',
        'Creating Forms and Form Validation in HTML and JavaScript',
        'Introduction to Web Accessibility',
        'Building a Basic Portfolio Website',
        'Introduction to APIs and Fetch Requests',
        'Using Browser Developer Tools for Debugging',
        'Basic Website Deployment with FTP',
        'Fundamentals of UI/UX Design',
        'Working with Images and Multimedia in Web Design'
      ],
      Intermediate: [
        'Advanced JavaScript and ES6+',
        'Asynchronous JavaScript: Promises and Async/Await',
        'Introduction to Web Frameworks (React, Vue, Angular)',
        'Introduction to Bootstrap for Frontend',
        'Working with APIs and Fetch',
        'Introduction to Node.js',
        'Creating Servers with Node.js and Express',
        'Managing Data with MongoDB',
        'Authentication in Web Applications (JWT)',
        'Introduction to RESTful API Design',
        'Introduction to WebSocket for Real-Time Communication',
        'Building Interactive Web Apps with Vue.js',
        'CRUD Operations with Node.js and MongoDB',
        'Understanding Web Security Fundamentals',
        'Handling User Input and Data Validation in Forms',
        'Introduction to Cross-Browser Compatibility',
        'Introduction to JavaScript Testing with Jest',
        'Handling File Uploads in Web Applications',
        'Building RESTful APIs with Express and MongoDB'
      ],
      Advanced: [
        'Advanced Frontend Development with React',
        'State Management in React with Redux',
        'Building Full Stack Applications with MERN Stack',
        'Advanced Node.js: Building Scalable APIs',
        'Authentication and Authorization with OAuth2',
        'Working with Cloud Databases (MongoDB Atlas)',
        'Real-Time Applications with WebSockets',
        'Optimizing Performance for Web Apps',
        'Responsive Web Design with Flexbox and Grid',
        'Deploying Web Apps with Docker and Kubernetes',
        'Version Control and Collaboration with GitHub',
        'Building Progressive Web Apps (PWAs)',
        'Microservices Architecture in Web Development',
        'Serverless Web Apps with AWS Lambda and API Gateway',
        'Advanced Routing and Navigation in React with React Router',
        'Web Security Best Practices for Full-Stack Apps',
        'API Rate Limiting and Caching Strategies',
        'Continuous Integration and Deployment (CI/CD) for Web Apps',
        'Building and Deploying APIs with GraphQL',
        'Implementing Server-Side Rendering (SSR) with React and Next.js'
      ]
    },
  
    8: { // Software Testing Course
      Beginner: [
        'Introduction to Software Testing',
        'Types of Software Testing: Manual vs Automated',
        'Software Testing Life Cycle (STLC)',
        'Test Case Design and Execution',
        'Introduction to Bug Tracking Tools',
        'Introduction to Functional Testing',
        'Introduction to Non-Functional Testing',
        'Black Box and White Box Testing Techniques',
        'Unit Testing and Test-Driven Development (TDD)',
        'Test Automation Introduction with Selenium',
        'Introduction to Test Management Tools',
        'Bug Reporting and Defect Lifecycle',
        'Basic API Testing with Postman',
        'Introduction to Test Plans and Strategies',
        'Introduction to Acceptance Testing',
        'Regression Testing Fundamentals',
        'Mobile Testing Fundamentals',
        'Introduction to Load and Stress Testing'
      ],
      Intermediate: [
        'Introduction to Automated Testing Frameworks',
        'Selenium WebDriver Basics',
        'Working with Java for Automated Testing',
        'WebDriver and Locators in Selenium',
        'Data-Driven Testing with Selenium',
        'Integration Testing and API Testing with Postman',
        'Continuous Integration and Test Automation',
        'Test Automation with JavaScript (Mocha, Chai)',
        'Performance Testing with JMeter',
        'Mobile Testing with Appium',
        'Database Testing and Validation Techniques',
        'Working with TestNG and JUnit for Java Testing',
        'Test Automation in Agile Environment',
        'API Documentation and Automation with Swagger',
        'Test-Driven Development (TDD) in Action',
        'Exploratory Testing Techniques',
        'Cross-Browser Testing with Selenium',
        'Security Testing with OWASP ZAP',
        'Test Automation with Cloud Services'
      ],
      Advanced: [
        'Advanced Test Automation Techniques',
        'Performance and Load Testing Strategies',
        'Advanced Selenium: Parallel Test Execution',
        'Continuous Integration in Test Automation',
        'Security Testing with OWASP ZAP',
        'Test Automation Frameworks and Best Practices',
        'Automated Testing in Agile Environment',
        'Testing in Microservices Architecture',
        'Implementing Continuous Testing with Jenkins',
        'Cloud-Based Testing Services',
        'AI in Software Testing: Intelligent Test Automation',
        'Visual Regression Testing',
        'Advanced Mobile Automation with Appium',
        'Test Automation for Cloud-Native Applications',
        'Implementing DevOps in Testing Process',
        'Automated Test Reporting and Metrics',
        'Robotic Process Automation (RPA) in Testing',
        'Test Automation for IoT Devices',
        'Creating Custom Test Automation Frameworks'
      ]
    },
  
    9: { // Digital Marketing Course
      Beginner: [
        'Introduction to Digital Marketing',
        'Understanding SEO Basics',
        'Keyword Research and Strategy',
        'On-Page and Off-Page SEO Techniques',
        'Google Analytics Basics',
        'Introduction to Content Marketing',
        'Social Media Marketing (Facebook, Twitter, Instagram)',
        'Building and Managing a Website for Digital Marketing',
        'Email Marketing Strategies',
        'Introduction to Paid Advertising (Google Ads, Facebook Ads)',
        'Understanding Landing Pages and Conversions',
        'Fundamentals of Video Marketing',
        'Google Search Engine Algorithm Basics',
        'Basics of Influencer Marketing',
        'Creating Engaging Social Media Content',
        'Introduction to Affiliate Marketing',
        'Fundamentals of Online Reputation Management',
        'Understanding Consumer Behavior in Digital Marketing'
      ],
      Intermediate: [
        'Advanced SEO Strategies',
        'Mobile Marketing',
        'Google Ads Campaigns and Optimization',
        'Building Effective Email Campaigns',
        'Building a Personal Brand Online',
        'Social Media Advertising (Facebook, Instagram Ads)',
        'Video Marketing for YouTube',
        'Affiliate Marketing Strategies',
        'Understanding Google Search Console',
        'Building and Managing a Digital Marketing Portfolio',
        'Remarketing Strategies with Google Ads',
        'Advanced Content Strategy for Websites and Blogs',
        'Utilizing Google Tag Manager for Enhanced Analytics',
        'Conversion Rate Optimization (CRO) Fundamentals',
        'Webinar and Online Event Marketing Strategies',
        'Implementing Cross-Channel Campaigns',
        'Using Analytics to Drive Marketing Decisions',
        'Lead Generation and Management Strategies',
        'Advanced Email Campaign Optimization'
      ],
      Advanced: [
        'Conversion Rate Optimization (CRO)',
        'Data-Driven Marketing Techniques',
        'Advanced Analytics and Reporting',
        'Building and Managing Google Ads Campaigns',
        'Advanced Email Marketing Campaigns',
        'Marketing Automation Tools',
        'Content Strategy and Management',
        'Influencer Marketing and Partnerships',
        'Advanced Social Media Marketing',
        'Growth Hacking for Digital Marketing',
        'Paid Social Media Campaign Management',
        'Customer Relationship Management (CRM) in Digital Marketing',
        'Multi-Channel Marketing Campaigns',
        'Programmatic Advertising and Real-Time Bidding',
        'Building and Scaling E-commerce Marketing Strategies',
        'Advanced Customer Segmentation and Targeting',
        'Building Cross-Functional Marketing Teams',
        'Artificial Intelligence and Machine Learning in Marketing'
      ]
    },
  
    10: { // SAP Training Program
      Beginner: [
        'Introduction to SAP and ERP Systems',
        'Understanding SAP Modules and Functionality',
        'Navigation and SAP GUI Basics',
        'Creating and Managing SAP Users',
        'Introduction to SAP Business Processes',
        'Understanding SAP System Configuration',
        'SAP Financial Accounting (FI) Basics',
        'SAP Materials Management (MM) Basics',
        'SAP Sales and Distribution (SD) Basics',
        'SAP Human Resources (HR) Basics',
        'Understanding SAP Reporting Tools',
        'Basic SAP Query and Reporting',
        'Introduction to SAP Business Workflow',
        'Data Entry and Processing in SAP',
        'Creating Basic SAP Reports'
      ],
      Intermediate: [
        'Advanced SAP Financial Accounting (FI)',
        'SAP Materials Management (MM) Advanced Topics',
        'SAP Sales and Distribution (SD) Advanced Topics',
        'SAP Advanced Human Resources (HR)',
        'SAP Production Planning (PP) Basics',
        'SAP Project Systems (PS) Introduction',
        'SAP Quality Management (QM) Basics',
        'SAP Integration with Other Modules',
        'SAP ABAP Programming Basics',
        'SAP System Customization and Configuration',
        'Advanced Reporting and Dashboards in SAP',
        'SAP Workflow Automation',
        'Master Data Management in SAP',
        'Building Custom Reports in SAP',
        'Advanced SAP Integration Techniques'
      ],
      Advanced: [
        'SAP Advanced Configuration and Implementation',
        'SAP S/4HANA Overview and Features',
        'SAP Advanced Financials and Accounting',
        'SAP Business Intelligence (BI) and Analytics',
        'SAP Advanced Sales and Distribution',
        'SAP Production Planning Advanced Features',
        'SAP Advanced Supply Chain Management',
        'SAP System Integration and Migration',
        'SAP Fiori and User Experience (UX)',
        'SAP HANA Cloud Solutions',
        'Advanced SAP Project Management',
        'SAP Business Process Optimization',
        'SAP Advanced Analytics and Data Science',
        'AI and Machine Learning in SAP',
        'SAP Cloud Platform and Integration Services',
        'SAP S/4HANA for Financials and Controlling'
      ]
    },
  
    11: { // Mobile Repair Technician Course
      Beginner: [
        'Introduction to Mobile Phone Repairing',
        'Understanding Mobile Phone Parts and Components',
        'Basic Mobile Tools and Equipment',
        'Mobile Device Types and Operating Systems',
        'Understanding Mobile Circuits and Schematics',
        'Mobile Display and Touchscreen Repair',
        'Battery and Charging Port Repair',
        'Mobile Camera Repair Techniques',
        'Repairing Mobile Audio Issues',
        'Software Issues and Flashing Phones',
        'Basic Software and Firmware Reprogramming',
        'Mobile Operating Systems: iOS vs Android Basics',
        'Basic Mobile Repair Safety Procedures',
        'Repairing and Replacing Mobile Speakers',
        'Mobile Power Button and Volume Button Repair'
      ],
      Intermediate: [
        'Mobile Repairing Safety and ESD Protection',
        'Repairing Motherboard and Circuit Boards',
        'Mobile Hardware Troubleshooting',
        'Repairing Mobile Sensors and Buttons',
        'Mobile Software Troubleshooting and Flashing',
        'Replacing Mobile Parts and Components',
        'Mobile Water Damage Repair Techniques',
        'Network and Signal Troubleshooting in Mobiles',
        'Upgrading and Rooting Android Phones',
        'Mobile Data Recovery and Backup',
        'Advanced Mobile Battery Troubleshooting and Replacement',
        'Mobile Screen Calibration and Testing',
        'Repairing Mobile Cameras for Better Picture Quality',
        'Software Optimization for Faster Mobile Performance',
        'Mobile Phone Modding and Customization Techniques'
      ],
      Advanced: [
        'Advanced Mobile Motherboard Repairing',
        'Micro-Soldering Techniques for Mobile Phones',
        'Advanced Software and Operating System Issues',
        'Mobile Phone Repair Business Setup and Management',
        'Mobile Repair Tools and Equipment for Professionals',
        'Dealing with Latest Mobile Technologies and Upgrades',
        'Mobile Repair Certification and Industry Standards',
        'Advanced Display Repair for OLED and AMOLED Screens',
        'Unlocking Phones and Carrier-Free Software',
        'Repairs for Mobile Gaming Consoles and Devices',
        'Advanced Mobile Phone Repair Diagnostics',
        'Mobile Repairing for Latest Models and Brands',
        'Mobile System Board Repairs and Upgrades'
      ]
    },
    
      12: { // TV Repair Technician Course
        Beginner: [
          'Introduction to TV Repairing',
          'Basic TV Components and Circuitry',
          'Understanding TV Display Technology (LCD, LED, OLED)',
          'Basic Electrical and Safety Principles in TV Repair',
          'Troubleshooting Common TV Issues',
          'TV Power Supply and Board Repair',
          'Replacing TV Screens and Panels',
          'Repairing TV Sound and Audio Issues',
          'Understanding TV Signal and Reception Issues',
          'TV Remote and Control Repair',
          'Basic Electrical Testing Tools for TV Repair',
          'Introduction to TV Diagnostics and Troubleshooting',
          'TV Power Issues and Repairing Power Boards',
          'Repairing Broken Screens and Panels',
          'Repairing HDMI and Input Issues in TVs',
          'Basic Calibration of TV Displays'
        ],
        Intermediate: [
          'Advanced TV Display Issues and Solutions',
          'In-depth Troubleshooting for TV Circuit Boards',
          'Repairing TV Power Supply Units',
          'TV Repairing Tools and Equipment',
          'Understanding Smart TV and Internet Issues',
          'TV System Integration and Software Troubleshooting',
          'LED and LCD Panel Backlight Repairing',
          'Screen Calibration and Alignment',
          'Panel and LCD Repair Techniques',
          'TV Maintenance and Prevention of Common Issues',
          'Advanced Troubleshooting for Display Issues',
          'TV Main Board Troubleshooting',
          'Repairing Wi-Fi and Bluetooth Issues in Smart TVs',
          'Repairing and Replacing TV Tuner Boards',
          'Understanding and Fixing TV Firmware Updates',
          'Restoring TV Firmware and Operating Systems',
          'Advanced Signal Repair and Troubleshooting'
        ],
        Advanced: [
          'Advanced TV Power Supply Troubleshooting',
          'Advanced Circuit Board Repairing',
          'Repairing LED, OLED, and QLED TVs',
          'TV Repair Business Management',
          'Dealing with Modern Smart TV Technology',
          'Advanced Troubleshooting Techniques for TVs',
          'TV Calibration and Repair Certification',
          'Using Oscilloscopes and Other Advanced Tools for TV Repairs',
          'Understanding and Repairing 4K and 8K Displays',
          'Advanced Audio and Soundboard Repair for High-End TVs',
          'Working with High-Voltage Circuitry in TV Repair',
          'Advanced Troubleshooting for Digital TV Tuners',
          'Repairing and Calibrating Large-Screen TVs',
          'Dealing with TV Panel Flickering and Dimming Issues',
          'Specialized Repair for Curved and Ultra-Thin TVs',
          'TV Repair Warranty and Customer Support Systems'
        ]
      },
    
      13: { // System Repair Technician Course
        Beginner: [
          'Introduction to System Repair',
          'Basic Computer Hardware and Components',
          'Basic Computer Troubleshooting Techniques',
          'System Boot-Up and Startup Issues',
          'Installing and Replacing Computer Parts',
          'Power Supply Issues and Fixes',
          'Troubleshooting Memory and RAM Issues',
          'Hard Disk and SSD Diagnostics',
          'Operating System and Software Installation',
          'Virus and Malware Removal Techniques',
          'Understanding and Repairing Computer Display Issues',
          'Basic Data Backup and Recovery Techniques',
          'Introduction to BIOS and UEFI Settings',
          'Understanding Computer Cooling Systems',
          'Installing and Configuring Peripheral Devices (Mouse, Keyboard, Printer)',
          'Basic Troubleshooting for Computer Networks',
          'Basic PC Assembly and Disassembly'
        ],
        Intermediate: [
          'Advanced Hardware Troubleshooting',
          'Motherboard Repair and Replacement',
          'Advanced Operating System Installation and Configuration',
          'Installing and Configuring Drivers and Software',
          'System Networking and Internet Connectivity Issues',
          'System Performance Optimization',
          'System Security and Antivirus Solutions',
          'Disk Partitioning and Recovery',
          'Understanding BIOS and UEFI Settings',
          'Power Supply and Cooling System Maintenance',
          'Installing and Configuring RAID Systems',
          'Data Recovery and Backup Techniques',
          'Building a Custom PC from Scratch',
          'System Diagnostics Using Advanced Tools (MemTest, BurnInTest)',
          'Troubleshooting Overheating and Cooling Issues in Systems',
          'Troubleshooting Blue Screens and System Crashes',
          'Networking Troubleshooting for Local and Remote Connections'
        ],
        Advanced: [
          'System Repairing for High-Performance PCs',
          'Overclocking and System Tuning',
          'Advanced Operating System Repairing',
          'Network Configuration and Advanced Connectivity Issues',
          'Data Recovery and System Backup Solutions',
          'Computer Hardware and Software Integration',
          'Building and Maintaining Gaming PCs',
          'System Repair Business Setup and Management',
          'Troubleshooting RAID Arrays and Disk Failures',
          'Handling Modern SSDs and M.2 NVMe Drives in PC Repairs',
          'Repairing and Upgrading GPUs and Graphics Cards',
          'Restoring and Reinstalling Operating Systems (Windows, Linux, macOS)',
          'Building Workstations for Specialized Applications',
          'Repairing Legacy Systems and Hardware',
          'Managing Firmware and BIOS Updates',
          'High-End Server Repair and Troubleshooting',
          'Creating and Managing Virtual Machines and Hypervisors'
        ]
      },
      14: {
  
  Beginner: [
    'Introduction to Accounting: Concepts and Principles',
    'Overview of Tally Prime and Its Use in Modern Accounting',
    'Zoho Books Basics: Setup and Dashboard Navigation',
    'Introduction to GST and Its Importance in Indian Finance',
    'TDS Overview and Deduction Mechanisms',
    'Income Tax Introduction: Applicability and Thresholds',
    'Microsoft Excel Interface, Shortcuts, and Basic Functions',
    'Types of Business Entities and Basic Bookkeeping Practices',
    'Ledger Creation and Voucher Entry in Tally Prime',
    'Creating Customer and Vendor Accounts in Zoho Books',
    'Invoice Generation and Payment Entries',
    'GST Registration and Invoicing Formats',
    'Filing TDS Returns: Step-by-Step',
    'Employee Information Setup in Payroll Modules',
    'Formatting Data and Basic Formulas in Excel',
    'Understanding Profit & Loss, Cash Book, and Trial Balance',
    'Using Tally for Journal and Contra Vouchers',
    'Basic Purchase and Sales Entries',
    'Chart of Accounts Configuration in Tally & Zoho Books',
    'Manual Payroll Calculation: DA, HRA, PF, etc.',
    'Reconciling Bank Statements with Cash Book',
    'Tracking Expenses and Receipts in Excel',
    'Introduction to Balance Sheet Structure',
    'Government Portals for Tax Filing (GST, TDS, IT)',
    'Types of Taxes: Direct vs Indirect',
    'Overview of Business Accounting Process Lifecycle',
    'Employee Payslip Generation Basics',
    'Backup and Restore in Tally Prime',
    'Using Pre-set Templates in Zoho Books',
    'Common Mistakes in Manual Accounting and How to Avoid Them'
  ],

  Intermediate: [
    'Intermediate Accounting Standards and IFRS Overview',
    'Inventory Management in Tally Prime: Stock Groups and Items',
    'Managing Multi-GST Scenarios and Reverse Charges',
    'Creating and Managing Recurring Invoices in Zoho Books',
    'Generating GSTR-1, GSTR-3B, and Annual Returns',
    'TDS Deduction and Filing with Payment Challan (Form 26Q)',
    'Income Tax Slabs, Deductions, and Computation Examples',
    'Excel Formulas: VLOOKUP, HLOOKUP, INDEX, MATCH',
    'Depreciation Calculation and Journal Entries',
    'Vendor Management and Purchase Orders in Zoho Books',
    'Advanced Voucher Configurations and Shortcut Keys',
    'Bank Reconciliation using Bank Feeds in Zoho Books',
    'Trial Balance Adjustment and Error Rectification',
    'Data Import/Export and Synchronization across Software',
    'GST Reconciliation and Matching with GSTR-2A',
    'Payroll Deductions (EPF, ESI, PT) and Compliance',
    'Generating and Customizing Financial Statements in Excel',
    'Cash Flow Statement Preparation in Tally and Excel',
    'Loan Accounting, EMI Schedules, and Interest Calculations',
    'Income Tax Computation using Excel Templates',
    'Project-wise and Department-wise Accounting',
    'Cost Centers and Cost Categories in Tally',
    'Creating MIS Reports and Dashboards in Excel',
    'Zoho Books Integration with Payment Gateways',
    'Advanced Invoice Templates and Terms Customization',
    'Audit Trail Activation and Log Review in Tally',
    'Payroll Management with Bonus, Incentives, and Overtime',
    'TDS on Rent, Contractor, and Professional Fees',
    'Excel Charts for Financial Visualization',
    'Preparation of Form 16, Form 26AS Review'
  ],

  Advanced: [
    'Enterprise Accounting Concepts and Compliance Frameworks',
    'Multi-Branch and Consolidated Accounting in Tally',
    'Setting Budgets and Controls in Zoho Books',
    'Excel Pivot Tables, Advanced Charts, and Data Modeling',
    'GST Audit Filing and Annual Reconciliation',
    'TDS e-Return Generation using RPU and FVU Utilities',
    'Income Tax Filing for Companies and LLPs',
    'Macro Creation in Excel for Automation',
    'Risk Assessment and Internal Control Procedures',
    'Statutory Payroll Reports and Labor Law Compliance',
    'Year-End Closing Entries and Balance Sheet Finalization',
    'Business Intelligence Reports from Zoho Books',
    'Internal Audit Practices and Documentation Standards',
    'ITR Filing using Government Portal (Income Tax India)',
    'EPF and ESI Portal Filing Procedures',
    'GSTR-9, GSTR-9C Filing with Reconciliation',
    'Bulk Data Processing and Validation in Excel',
    'Working with Tally ODBC and Excel Integration',
    'Excel VBA for Financial Automation',
    'Scenario Management and Forecasting in Zoho',
    'Managing Arrears, Gratuity, and Full & Final Settlements',
    'Internal Audit Checklist and Risk Matrix',
    'GST Notices and Department Query Handling',
    'Preparation of Income & Expenditure Statements',
    'Revising Tax Returns and Handling Refunds',
    'Accounting for Foreign Currency Transactions',
    'Statutory Compliance Calendar Creation',
    'Payroll Audits and Salary Structuring',
    'Advanced Integration of Tally with ERP or CRM',
    'Case Studies: Real-World Accounting and Tax Scenarios'
  ]
}
,
15: {
  Beginner: [
    'Introduction to Makeup Artistry',
    'Understanding Skin Types and Skin Care',
    'Makeup Tools and Their Uses',
    'Basic Makeup Application Techniques',
    'Color Theory and Foundation Matching',
    'Daytime and Natural Look Makeup',
    'Eye Makeup Basics – Eyeliners and Mascara',
    'Lip Makeup Basics',
    'Face Shapes and Contouring',
    'Hygiene and Sanitation in Makeup',
    'Introduction to Bridal Makeup',
    'Product Knowledge and Selection',
    'Basic Facial Anatomy for Makeup Artists',
    'Client Consultation and Communication',
    'Basic Makeup Removal Techniques'
  ],
  Intermediate: [
    'Advanced Makeup Techniques and Styles',
    'Evening and Party Makeup',
    'Smokey Eye and Bold Lip Looks',
    'Bridal Makeup Detailed Techniques',
    'Airbrush Makeup Application',
    'Special Occasion and Event Makeup',
    'Makeup for Different Skin Tones',
    'Corrective Makeup for Scars and Blemishes',
    'False Lashes Application',
    'Basic Hair Styling for Makeup Artists',
    'Photography and Media Makeup',
    'Working with Different Makeup Brands',
    'Building a Makeup Kit',
    'Time Management and Client Scheduling',
    'Introduction to Makeup Business'
  ],
  Advanced: [
    'Special Effects Makeup and Prosthetics',
    'Fashion and Runway Makeup',
    'Makeup for Film, TV, and Theatre',
    'Hairstyling Advanced Techniques',
    'Bridal Makeup Mastery and Trends',
    'Makeup for Different Ethnicities',
    'Makeup Business Setup and Marketing',
    'Client Portfolio Building',
    'Social Media for Makeup Artists',
    'Advanced Airbrush and HD Makeup',
    'Corrective and Camouflage Makeup',
    'Makeup for Aging Skin',
    'Consulting and Personal Branding',
    'Workshops and Training Others',
    'Trends and Innovations in Makeup Industry'
  ]
}

  
};



const courseFAQs = {
  1: [ /* Java Full Stack Course */
    { question: "What is the prerequisite for Java Full Stack?", answer: "Basic understanding of Java programming." },
    { question: "What tools do I need?", answer: "You'll need an IDE like IntelliJ IDEA and a local database server like MySQL." },
    { question: "Is this course suitable for beginners?", answer: "Yes, the course starts with basic Java concepts and moves towards advanced full-stack development." },
    { question: "Do I need to learn front-end technologies?", answer: "Yes, you'll learn HTML, CSS, JavaScript, and React for the front-end." },
    { question: "Is there any project work in this course?", answer: "Yes, there are hands-on projects and exercises for practice." },
    { question: "Will we be working with databases?", answer: "Yes, we'll cover SQL databases like MySQL and database interaction with Java." },
    { question: "What is the duration of the course?", answer: "The course typically takes around 6 months to complete." },
    { question: "Will this course help me become a full-stack developer?", answer: "Yes, this course will teach both back-end and front-end development, making you a full-stack developer." },
    { question: "Can I work on my own projects during the course?", answer: "Yes, you're encouraged to apply the concepts learned in the course to personal projects." },
    { question: "Do I need to know anything about web development?", answer: "No, we will cover everything from the basics of web development to advanced topics." }
  ],

  2: [ /* Python Full Stack Course */
    { question: "Do I need prior knowledge of Python?", answer: "Basic programming knowledge is helpful but not necessary." },
    { question: "Which libraries will we use?", answer: "We'll use Flask for the backend and React for the frontend." },
    { question: "Is this course suitable for beginners?", answer: "Yes, the course starts with Python fundamentals and covers full-stack development." },
    { question: "Do I need to know JavaScript?", answer: "Yes, we will cover JavaScript basics, as it is used for the front-end development in this course." },
    { question: "What is Flask?", answer: "Flask is a lightweight web framework for building web applications in Python." },
    { question: "Will we work with databases?", answer: "Yes, we'll work with SQL databases using SQLAlchemy and integrate them with Flask." },
    { question: "What is React?", answer: "React is a JavaScript library for building user interfaces, primarily for single-page applications." },
    { question: "Will I get hands-on experience?", answer: "Yes, there are projects and exercises throughout the course to apply what you learn." },
    { question: "Is it possible to learn this course without prior web development experience?", answer: "Yes, the course is designed for beginners and gradually introduces you to web development." },
    { question: "How long will it take to complete the course?", answer: "On average, it will take around 6 months to complete the full-stack course." }
  ],

  3: [ /* AI and Machine Learning */
    { question: "Do I need a background in math for AI?", answer: "Yes, a basic understanding of linear algebra and calculus is helpful." },
    { question: "What tools will be used in the course?", answer: "We'll use Python libraries like TensorFlow, Keras, and Scikit-learn." },
    { question: "Do I need programming experience?", answer: "Yes, basic programming knowledge in Python is required." },
    { question: "Will we work with real-world datasets?", answer: "Yes, the course includes practical exercises using real-world datasets for training machine learning models." },
    { question: "What is the duration of the course?", answer: "The course is typically 6-8 months long." },
    { question: "Is this course suitable for beginners?", answer: "Yes, we start with the fundamentals of AI and machine learning and build up to more complex topics." },
    { question: "Will I be able to build machine learning models?", answer: "Yes, the course includes hands-on projects where you'll build and deploy machine learning models." },
    { question: "What is supervised learning?", answer: "Supervised learning is a type of machine learning where the model is trained on labeled data." },
    { question: "Do I need to learn deep learning?", answer: "Yes, the course includes a section on deep learning, including neural networks and advanced architectures." },
    { question: "Can I use AI for business applications?", answer: "Yes, the skills learned can be applied to real-world business problems, such as predictions and optimizations." }
  ],

  4: [ /* Data Science Masterclass */
    { question: "What is data science?", answer: "Data science is a multidisciplinary field that uses scientific methods, algorithms, and systems to extract insights from structured and unstructured data." },
    { question: "Do I need a background in math for data science?", answer: "A basic understanding of statistics and probability is recommended." },
    { question: "What tools and languages will we use?", answer: "We will use Python, R, SQL, and tools like Jupyter Notebooks, Pandas, and Matplotlib." },
    { question: "Is this course beginner-friendly?", answer: "Yes, the course starts with the basics and progresses to advanced data science concepts." },
    { question: "Will we cover machine learning?", answer: "Yes, machine learning is a key part of the course, including supervised and unsupervised learning." },
    { question: "How long does the course last?", answer: "The course typically lasts 6-8 months depending on the pace." },
    { question: "Do I need prior experience with programming?", answer: "Basic programming experience, especially in Python, is recommended but not mandatory." },
    { question: "What kind of projects will we work on?", answer: "The course includes projects like data cleaning, exploratory data analysis, and predictive modeling." },
    { question: "Will this course help me get a job in data science?", answer: "Yes, this course equips you with the necessary skills and knowledge to pursue a career in data science." },
    { question: "Is there a certification at the end of the course?", answer: "Yes, upon successful completion of the course, you will receive a certificate." }
  ],

  5: [ /* Cybersecurity Course */
    { question: "Do I need prior knowledge of cybersecurity?", answer: "Basic understanding of networking and computer systems is helpful but not necessary." },
    { question: "What will we cover in this course?", answer: "We cover topics like ethical hacking, network security, encryption, and risk management." },
    { question: "Do I need to know programming?", answer: "Basic programming knowledge is helpful but not required." },
    { question: "Which tools will be used?", answer: "We will use tools like Kali Linux, Wireshark, and Metasploit for hands-on practice." },
    { question: "How long will the course take?", answer: "The course is typically 4-6 months long." },
    { question: "Will I get hands-on practice?", answer: "Yes, the course includes practical labs and exercises to simulate real-world cybersecurity challenges." },
    { question: "What certifications can I get?", answer: "After completing the course, you can pursue certifications like CEH (Certified Ethical Hacker) or CompTIA Security+." },
    { question: "Is this course suitable for beginners?", answer: "Yes, we cover foundational concepts in cybersecurity before moving to more advanced topics." },
    { question: "What are the career opportunities after completing this course?", answer: "You can pursue roles like cybersecurity analyst, ethical hacker, or network security engineer." },
    { question: "Can I start my own cybersecurity consulting firm?", answer: "Yes, the skills learned can help you start your own cybersecurity consultancy." }
  ],

  6: [ /* Cloud & DevOps Course */
    { question: "What is DevOps?", answer: "DevOps is a set of practices that combines software development (Dev) and IT operations (Ops) to shorten the development lifecycle." },
    { question: "What tools will we use in this course?", answer: "We will use tools like Docker, Jenkins, Kubernetes, AWS, and Terraform." },
    { question: "Do I need prior experience in cloud computing?", answer: "Basic understanding of cloud computing is recommended but not necessary." },
    { question: "How long is the course?", answer: "The course is typically 6 months long." },
    { question: "Will we work with cloud platforms?", answer: "Yes, we will primarily work with AWS, but we also cover other cloud platforms like Azure and Google Cloud." },
    { question: "What are the benefits of DevOps?", answer: "DevOps helps in automating workflows, reducing software delivery time, and improving collaboration between development and operations teams." },
    { question: "Do I need programming skills for this course?", answer: "Basic scripting knowledge, especially in Python or Bash, is helpful but not mandatory." },
    { question: "Is this course suitable for beginners?", answer: "Yes, we start with the basics of DevOps and cloud computing and gradually move to more advanced topics." },
    { question: "What will be the final project?", answer: "The final project will involve setting up a complete DevOps pipeline using cloud platforms and tools." },
    { question: "What career opportunities can I pursue after completing this course?", answer: "You can pursue roles like DevOps Engineer, Cloud Engineer, or Site Reliability Engineer." }
  ],

  7: [ /* Web Development Course */
    { question: "Is prior programming experience necessary?", answer: "No, the course starts with basic HTML, CSS, and JavaScript and builds up from there." },
    { question: "Will we cover front-end frameworks?", answer: "Yes, we'll cover popular frameworks like React and Bootstrap." },
    { question: "What backend technologies will we use?", answer: "We'll focus on Node.js for backend development, along with Express.js." },
    { question: "Do I need to learn databases?", answer: "Yes, we'll learn about MongoDB for NoSQL and MySQL for relational databases." },
    { question: "What will I learn in this course?", answer: "You'll learn full-stack development, from building static websites to dynamic web apps with back-end functionality." },
    { question: "How long will it take to complete?", answer: "On average, this course takes around 4-6 months." },
    { question: "Will I be able to create my own web apps?", answer: "Yes, you'll complete projects that will allow you to create and deploy your own web applications." },
    { question: "What if I already know some of the topics?", answer: "If you're already familiar with some topics, you can go through them quickly or focus on areas you need more practice." },
    { question: "Is there a final exam?", answer: "Yes, there will be a final project where you will develop a fully functional web app." },
    { question: "Can I work in the industry after completing this course?", answer: "Yes, you'll be equipped with the skills necessary for a junior web developer role." }
  ],

  8: [ /* Software Testing Course */
    { question: "Do I need programming knowledge?", answer: "No, but a basic understanding of programming concepts can help." },
    { question: "What testing methodologies will we cover?", answer: "We'll cover manual testing, automated testing, and Agile testing methodologies." },
    { question: "What tools will we use?", answer: "We will use tools like Selenium, JIRA, and Postman for testing." },
    { question: "How long is the course?", answer: "Typically, the course lasts 4-6 months." },
    { question: "Will I get hands-on experience?", answer: "Yes, the course includes practical projects and assignments on software testing." },
    { question: "What types of testing will we learn?", answer: "You'll learn unit testing, integration testing, UI testing, and API testing." },
    { question: "Do I need to know the SDLC?", answer: "Yes, understanding the Software Development Life Cycle (SDLC) will help in testing." },
    { question: "Will this course prepare me for certifications?", answer: "Yes, you can pursue certifications like ISTQB (International Software Testing Qualifications Board) after completing this course." },
    { question: "What career opportunities are there in software testing?", answer: "You can pursue roles like Software Tester, QA Engineer, or Automation Engineer." },
    { question: "What is the final project?", answer: "The final project involves performing full software testing on an application or system." }
  ],

  9: [ /* Digital Marketing Course */
    { question: "Will we learn SEO?", answer: "Yes, SEO (Search Engine Optimization) is a key component of the course." },
    { question: "Do I need prior experience in marketing?", answer: "No, this course is designed for beginners in the marketing field." },
    { question: "What platforms will we focus on?", answer: "We will cover platforms like Google Ads, Facebook, Instagram, and LinkedIn." },
    { question: "How long is the course?", answer: "The course typically lasts 4-6 months." },
    { question: "Will I get practical experience?", answer: "Yes, the course includes live campaigns and projects to apply your learning." },
    { question: "What is content marketing?", answer: "Content marketing involves creating valuable content to attract and engage potential customers." },
    { question: "Will I learn about email marketing?", answer: "Yes, we'll cover strategies for effective email marketing campaigns." },
    { question: "Do I need to know how to use design tools?", answer: "Basic knowledge of design tools like Canva and Photoshop will be helpful but not mandatory." },
    { question: "Is there a certification at the end of the course?", answer: "Yes, you will receive a certificate upon completion of the course." },
    { question: "Can I start my own digital marketing agency?", answer: "Yes, the course provides the skills needed to run your own digital marketing business." }
  ],
  10: [ /* SAP Training Program */
    { question: "What is SAP?", answer: "SAP is a software platform that helps businesses manage their operations and customer relations." },
    { question: "Do I need prior experience with SAP?", answer: "No, the course is designed for beginners, and we cover the basics of SAP." },
    { question: "Which modules of SAP will we cover?", answer: "We will cover various modules such as SAP ERP, SAP HANA, and SAP CRM." },
    { question: "What tools do I need for this course?", answer: "You will need a computer with internet access, and SAP GUI installed to practice." },
    { question: "How long does the SAP course take?", answer: "The course typically lasts 3 to 6 months depending on your pace." },
    { question: "What job roles can I pursue after completing SAP training?", answer: "You can pursue roles such as SAP consultant, SAP developer, or SAP project manager." },
    { question: "Do I need to know programming for this course?", answer: "Basic knowledge of programming can be helpful, but it is not mandatory." },
    { question: "Is there any certification provided?", answer: "Yes, upon successful completion of the course, you will receive an SAP certification." },
    { question: "Is there any practical application in this course?", answer: "Yes, you will work on real-world SAP projects and case studies to gain hands-on experience." },
    { question: "Will this course help me get a job?", answer: "Yes, SAP skills are highly in demand, and the course can help you land a job as an SAP consultant or developer." }
  ],

  11: [ /* Mobile Repair Technician Course */
    { question: "Do I need prior knowledge of mobile repairs?", answer: "No, this course is designed for beginners and covers everything from the basics." },
    { question: "What tools will I need for mobile repairs?", answer: "You will need a set of mobile repair tools, including screwdrivers, opening tools, and anti-static equipment." },
    { question: "What types of mobile devices will I learn to repair?", answer: "You will learn to repair smartphones, tablets, and other common mobile devices." },
    { question: "How long does the course last?", answer: "The course typically takes 3 to 6 months, depending on the pace of learning." },
    { question: "What skills will I gain in this course?", answer: "You'll learn how to diagnose, troubleshoot, and repair mobile devices, including hardware and software issues." },
    { question: "Can I start my own mobile repair business?", answer: "Yes, after completing the course, you can start your own mobile repair business or work as a technician." },
    { question: "Will I get hands-on experience?", answer: "Yes, the course includes practical sessions to repair mobile devices under expert supervision." },
    { question: "Is there a certification at the end of the course?", answer: "Yes, you will receive a certificate of completion after finishing the course." },
    { question: "What career opportunities can I explore after this course?", answer: "You can work as a mobile repair technician, service center manager, or start your own mobile repair business." },
    { question: "Do I need to have a technical background?", answer: "No, prior technical knowledge is not necessary, as the course covers everything from the basics." }
  ],

  12: [ /* TV Repair Technician Course */
    { question: "Do I need prior experience with TV repairs?", answer: "No, this course is designed for beginners with no prior experience." },
    { question: "What types of TVs will we learn to repair?", answer: "You'll learn to repair various types of TVs, including LED, LCD, Plasma, and Smart TVs." },
    { question: "What tools will I need for TV repairs?", answer: "You'll need basic electronic repair tools like screwdrivers, soldering iron, multimeter, and other diagnostic tools." },
    { question: "How long will the course take?", answer: "The course usually takes 4 to 6 months to complete." },
    { question: "What skills will I gain from this course?", answer: "You'll learn how to troubleshoot and repair common TV issues, both hardware and software-related." },
    { question: "Can I start a business after completing this course?", answer: "Yes, you can start your own TV repair business or work in service centers." },
    { question: "Is there a certification at the end of the course?", answer: "Yes, after completing the course, you will receive a certification." },
    { question: "What career opportunities are available after this course?", answer: "You can work as a TV repair technician or in a service center for major TV brands." },
    { question: "Will this course include practical training?", answer: "Yes, the course includes hands-on training to repair various TV models and brands." },
    { question: "Do I need to understand electronics for this course?", answer: "Basic understanding of electronics is helpful but not mandatory, as we cover all essential concepts." }
  ],

  13: [ /* System Repair Technician Course */
    { question: "Do I need prior experience in system repairs?", answer: "No, the course is designed for beginners, and we will teach you all the necessary skills." },
    { question: "What will I learn in this course?", answer: "You will learn to diagnose, troubleshoot, and repair issues in desktops, laptops, and computer peripherals." },
    { question: "What tools will I need?", answer: "You will need basic tools such as screwdrivers, multimeters, thermal paste, and a laptop repair kit." },
    { question: "How long is the course?", answer: "The course duration is typically 4 to 6 months, depending on your learning pace." },
    { question: "What kinds of systems will I repair?", answer: "You'll repair desktop PCs, laptops, and components like hard drives, motherboards, and more." },
    { question: "Can I start my own repair business?", answer: "Yes, the skills learned in this course can help you start your own computer repair business." },
    { question: "Will I get hands-on experience?", answer: "Yes, the course includes practical training to repair real systems." },
    { question: "Is there a certification at the end of the course?", answer: "Yes, you will receive a certificate after completing the course." },
    { question: "What are the career opportunities after completing the course?", answer: "You can work as a system repair technician, IT support specialist, or open your own repair shop." },
    { question: "Do I need any prior knowledge of computers?", answer: "Basic computer knowledge is helpful but not required as we cover all the necessary concepts from scratch." }
  ],
  14: [
  { question: "What is CIF in banking?", answer: "CIF stands for Customer Information File, which contains all customer data used by banks for account management." },
  { question: "Do I need prior banking experience?", answer: "No prior experience is required; this course is designed for beginners." },
  { question: "What will I learn in this course?", answer: "You will learn about data entry, KYC verification, compliance regulations, and maintaining secure customer records." },
  { question: "How long is the course?", answer: "The course typically lasts 3 to 5 months, depending on your learning speed." },
  { question: "Will there be practical sessions?", answer: "Yes, you will practice using banking software and handling sample customer files." },
  { question: "Is certification provided?", answer: "Yes, a certificate will be issued upon successful completion." },
  { question: "Are there job opportunities after this course?", answer: "Yes, you can work as a banking operations executive, data entry operator, or customer support specialist." },
  { question: "Do I need computer skills?", answer: "Basic computer knowledge is helpful but not mandatory." },
  { question: "Can I pursue advanced banking courses later?", answer: "Absolutely, this course is a great foundation for further banking and finance studies." },
  { question: "Is this course relevant for remote jobs?", answer: "Yes, many banking operations roles offer remote work options." }
],
15: [
  { question: "Do I need prior makeup experience?", answer: "No experience needed; the course covers basics to advanced techniques." },
  { question: "What topics does the course cover?", answer: "Skin care, makeup tools, day & evening looks, bridal makeup, special effects, and client handling." },
  { question: "How long is the course?", answer: "The course duration is about 4 to 6 months with practical sessions." },
  { question: "Will I get hands-on practice?", answer: "Yes, practical training is a key part of the course." },
  { question: "Do you provide makeup kits?", answer: "Some starter kits may be provided; you can also purchase recommended products." },
  { question: "Is certification offered?", answer: "Yes, you will receive a professional certification after completion." },
  { question: "Can I work as a freelance makeup artist?", answer: "Yes, the course prepares you for freelance or salon work." },
  { question: "Are there career opportunities in film and fashion?", answer: "Yes, we cover techniques relevant to film, TV, and fashion industry." },
  { question: "Do you teach special effects makeup?", answer: "Yes, basic special effects makeup is included in the syllabus." },
  { question: "Can I start my own makeup business?", answer: "Definitely, we provide guidance on building your makeup artist career and business." }
]


};

const CourseDetails = () => {
  const { id } = useParams();
  const course = courseData[id];
  const syllabus = courseSyllabuses[id] || {};
  const faqs = courseFAQs[id] || [];

  if (!course) {
    return <div>Course not found</div>;
  }

  return (
    <div className="course-details-container">
      <div className="course-details">
        <div className="course-details-image">
          <img src={course.image} alt={course.title} />
        </div>
        <div className="course-details-info">
          <h1 className="course-title">{course.title}</h1>
          <h3 className="course-category">{course.category}</h3>
          <p className="course-description">{course.description}</p>
          <div className="course-rating">
            <p>Rating: {course.rating.rate} / 5</p>
          </div>
        </div>
      </div>

      <div className="course-syllabus">
        <h2>Syllabus</h2>
        {Object.entries(syllabus).map(([level, topics], index) => (
          <LevelDropdown key={index} level={level} topics={topics} />
        ))}
      </div>

      <div className="course-faq">
        <h2>FAQs</h2>
        {faqs.map((faq, index) => (
          <FaqDropdown key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </div>
  );
};

const LevelDropdown = ({ level, topics }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="dropdown-item">
      <button className={`dropdown-btn ${isOpen ? 'opened' : ''}`} onClick={toggleDropdown}>
        <span>{level} Level</span>
        <i className={`fas ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
      </button>
      {isOpen && (
        <div className="dropdown-content">
          <ul>
            {topics.map((topic, idx) => (
              <li key={idx}>{topic}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const FaqDropdown = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="dropdown-item">
      <button className={`dropdown-btn ${isOpen ? 'opened' : ''}`} onClick={toggleDropdown}>
        <span>{question}</span>
        <i className={`fas ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
      </button>
      {isOpen && (
        <div className="dropdown-content">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

export default CourseDetails;
